module.exports = __webpack_public_path__ + "static/media/namrata.20631846.png";